import { render, staticRenderFns } from "./leaves.vue?vue&type=template&id=c81ed776&"
import script from "./leaves.vue?vue&type=script&lang=js&"
export * from "./leaves.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports